import Icon from 'veui/components/Icon'
import { IconImage } from 'dls-icons-vue'

Icon.register('image', IconImage)
